import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["all", "discipline"]

  selectAll() {
    this.allTarget.checked = true
    this.disciplineTargets.forEach((checkbox) => { checkbox.checked = false })
  }

  toggle() {
    const checkedCount = this.disciplineTargets.filter((checkbox) => checkbox.checked).length
    const isAllMode = checkedCount === 0 || checkedCount === this.disciplineTargets.length

    if (isAllMode) {
      this.selectAll()
    } else {
      this.allTarget.checked = false
    }
  }
}
